import {
    SUPPLIES_SEARCH,
    SUPPLIES_SEARCH_LOADING,
    SUPPLIES_SEARCH_KEYWORD,
    SUPPLIES_RESET,
} from './suppliesSearchActions';

const initialState = {
    searchResults: null,
    loading: false,
    latestSearch: '',
};

const SuppliesSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUPPLIES_SEARCH: {
            const { results, keyword, options } = action;

            // TODO: temporary fix for late request, ideally should be cancelled
            if (keyword !== state.latestSearch) {
                return { ...state };
            }

            return { ...state, results, options };
        }
        case SUPPLIES_SEARCH_LOADING: {
            const { loading } = action;
            return { ...state, loading };
        }
        case SUPPLIES_SEARCH_KEYWORD: {
            const { latestSearch } = action;
            return { ...state, latestSearch };
        }
        case SUPPLIES_RESET: {
            return { ...state, results: null, keyword: '' };
        }
        default:
            return state;
    }
};

export default SuppliesSearchReducer;
